import {commentTrendDataLoader} from '../../../util/dataLoader';
import {ICommentTrendAPIResponse} from './commentTrendSlice';


export function getCommentTrend(filters) {
  return new Promise<ICommentTrendAPIResponse>((resolve) => {
    commentTrendDataLoader.get(filters).then((res: ICommentTrendAPIResponse) => {
      resolve(res)
    })
  })
}
